export default __webpack_public_path__ + "static/bestview-grounds2-cf289980653f480d579abe154ba0e567.jpg";